//turns fn into an Iefe string used to generate webworkers at run time https://developer.mozilla.org/en-US/docs/Glossary/IIFE
export const getIefeString = (fn: (...args: any[]) => any) => {
  return `(${fn.toString()})();`;
};
